import axios from 'axios';
import Cookies from 'js-cookie';
// import Qs from 'qs';

const Axios = axios.create({
  baseURL: 'https://api.booknow.tw/book',
  headers: { 'Content-Type': 'application/json' },
  transformRequest: [(data) => {
    const newData = data;
    if (Cookies.get('s')) newData.s = Cookies.get('s');

    return JSON.stringify(newData);
  }],
});

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response?.data?.message) {
        // eslint-disable-next-line
        window.alert(error.response.data.message);
      }

      if (error.response?.data?.redirect) {
        this.$router.push(error.response.data.redirect);
      }
    }

    return Promise.reject(error);
  },
);

Axios.interceptors.request.use(
  (instance) => {
    const config = { ...instance };
    const utk = Cookies.get('utk') || null;

    if (utk) {
      config.headers.Authorization = `Bearer ${utk}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default Axios;
